import { render, staticRenderFns } from "./FletrixCombobox.vue?vue&type=template&id=4c23b726&"
import script from "./FletrixCombobox.vue?vue&type=script&lang=js&"
export * from "./FletrixCombobox.vue?vue&type=script&lang=js&"
import style0 from "./FletrixCombobox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCombobox } from 'vuetify/lib/components/VCombobox';
installComponents(component, {VCombobox})
